import React from "react";
import { motion } from "framer-motion";

export default function MasonryIntro() {
  return (
    <section
      data-testid="masonry-intro"
      className="relative py-24 md:py-32 lg:py-40 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <div className="flex items-center gap-3 text-[#B8965A]">
            <span className="block w-8 h-px bg-[#C9A86A]" />
            <span className="text-[11px] uppercase tracking-[0.3em]">
              What We Do
            </span>
          </div>
          <h2 className="mt-6 font-display-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter text-[#0A0A0A]">
            Stone Masonry, Tiling &{" "}
            <span className="font-serif-italic font-light text-[#B8965A]">
              Restoration Services.
            </span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7 lg:pt-4"
        >
          <p className="text-[#525252] text-base md:text-lg leading-relaxed">
            We specialise in cutting, shaping and finishing hard and soft stone
            blocks, slabs and masonry for the construction, renovation and
            repair of stone structures and kitchen benchtops. Our team also
            handles complete tiling — supply, layout and installation of
            natural stone, porcelain and ceramic tiles across floors, walls,
            bathrooms and outdoor areas. We finish every project with expert
            stone restoration, grinding, honing, polishing, repair and surface
            refinishing for natural stone and marble.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
